import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FileService } from "../../../core/services/contenful/file.service";
import { Constants } from 'src/app/core/constants/constants';
import { FileModel } from 'src/app/core/models/entities/file.model';

@Component({
    selector: "app-documents",
    templateUrl: "./documents.component.html",
    styleUrls: ["./documents.component.scss"],
})
export class DocumentsComponent implements OnInit {
    readonly enUS = "en-US";
    files = [];
    constructor(private fileService: FileService, private titleService: Title) {
        this.titleService.setTitle("Fichiers de formation");
    }

    ngOnInit() {
        this.loadFiles();
    }

    loadFiles() {
        this.fileService.getAll().subscribe((datas: FileModel[]) => {
            this.files = datas.map((item: FileModel) => {
                const data = {
                    ...item,
                    name: item.name || "Sans nom",
                    description: item.description || "Pas de description",
                };

                return data;
            });
        });
    }

    downloadFromContentful(file: FileModel) {
        this.fileService.getUrlFromAsset(file.sourceId).subscribe((fileUrl: string)=>{

            const url = fileUrl.startsWith("http") ? fileUrl : `https:${fileUrl}`;

            const link = document.createElement("a");
            link.href = url;
            link.download = file.name;
            link.target = "_blank";

            link.click();
        });
    }
}
